/*
 * pure request builders for the upload endpoints. request_fields.test.js checks each one sends
 * EXACTLY the fields its goserver handler reads.
 */
import { api_pay_month } from '../params';
import { UPLOAD_LIMITS } from './params';
import { decisions_payload } from './decisions';

// multipart fields of POST /additional/upload/validate; to_form_data turns them into the body.
// category (a code) is always sent; '' means "use each row's category column".
export const validate_fields = (file, pay_month, category = '') => ({
  file,
  pay_month: api_pay_month(pay_month),
  category: String(category || '').trim()
});

export const to_form_data = (fields) => {
  const form = new FormData();
  Object.keys(fields).forEach((k) => form.append(k, fields[k]));
  return form;
};

export const run_params = (run_uuid) => ({ run_uuid });

export const file_params = (run_uuid) => ({ run_uuid });

export const runs_params = (pay_month, limit = UPLOAD_LIMITS.RUNS_LIMIT_DEFAULT, offset = 0) => ({
  pay_month: api_pay_month(pay_month),
  limit: Math.min(limit || UPLOAD_LIMITS.RUNS_LIMIT_DEFAULT, UPLOAD_LIMITS.RUNS_LIMIT_MAX),
  offset: offset || 0
});

/*
 * Invalid rows are acknowledged by their COUNT (the tick); every other row by a decision. decisions
 * is always sent (even []), so the server ignores the old confirm counts and they are left out.
 */
export const apply_payload = (run, ticks, decisions = null) => {
  const counts = (run && run.counts) || {};
  const t = ticks || {};
  return {
    run_uuid: run.run_uuid,
    skip_invalid_count: t.skip_invalid ? counts.invalid || 0 : 0,
    decisions: decisions_payload((run && run.rows) || [], decisions || {})
  };
};

export const discard_payload = (run_uuid, reason) => ({
  run_uuid,
  reason: String(reason || '').trim()
});

// POST /recalc: one teacher per call, month as a first-of-month date like every endpoint.
export const recalc_payload = (teacher_uuid, pay_month) => ({
  teacher_uuid,
  pay_month: api_pay_month(pay_month)
});
